import React, { useState, useEffect, useRef } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/system';
import { useCallback } from 'react';


const theme = createTheme({
  palette: {
    primary: {
      main: '#d4d2d2',
    },
    background: {
      default: '#fff',
    },
  },
});

const StyledContainer = styled(Container)`
  margin-top: 20px;
  background-color: white;
  padding: 40px;
  /* border-radius: 8px; */
`;

const StyledAppBar = styled(AppBar)`
  background-color: #005E8F;
`;

const StyledToolbar = styled(Toolbar)`
  background-color: #feffff;
  `;

const HeadingContainer = styled('div')`
    font-family: Helvetica,Arial,sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 86px;
    line-height: 64.0002px;
    letter-spacing: 0px;
    text-transform: none;
    font-stretch: normal;
    padding: 0.5px 0px;
`;

const HeadingTypography = styled('p')`
  /* position: relative; */
  color: black;
  text-align: center;
  max-width: max-content;
  font-size: 32px ;
`;

const StyledSelect = styled(Select)`
  color: black;
  margin-left: auto;
`;

const StyledCard = styled(Card)`
  height: 100%;
  max-width: 75%;
  margin-bottom: 20px;
`;

const PaginationContainer = styled(Grid)`
  margin-top: 20px;
`;

const CardTitleTypography = styled(Typography)`
    margin: 0;
    font-family: Escrow Condensed,Georgia,serif;
    font-size: 24px;
    line-height: 28.0001px;
    font-weight: 700;
    letter-spacing: 0px;
    font-style: normal;
    text-transform: none;
    font-stretch: normal;
    padding: 0.5px 0px;

`;

const CardDescTypography = styled('p')`
margin: 0;
    color: rgba(86, 84, 84, 1);
    font-family: Helvetica,Arial,sans-serif;
    font-size: 21px;
    line-height: 24px;
    font-weight: 350;
    letter-spacing: 0px;
    font-style: normal;
    text-transform: none;
    font-stretch: normal;
    padding: 0.5px 0px;
    margin-block-start: 16px;
`;

const AppBarGrid = styled('Grid')`
margin-top: 20px;
`;

const BlogList = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();

  const fetchDataFromAPI = async (category, page) => {
    // Simulate API call delay
    await new Promise((resolve) => setTimeout(resolve, 1000));
  
    // Replace this with your actual API call
    // For demonstration purposes, it returns some sample data
    return [
      { title: `Yandex Owner to Sever Ties to Russia With $5.2 Billion Sale`, category, content: 'Russia’s largest search engine will be sold to a group of local investors in the biggest corporate exit from the country since the war in Ukraine began', author: 'John Doe', readTime: '5 min', date: '2022-03-15' },
      { title: `New Blog ${page * 3 + 2}`, category, content: 'Lorem ipsum...', author: 'Jane Smith', readTime: '8 min', date: '2022-03-16' },
      { title: `New Blog ${page * 3 + 3}`, category, content: 'Lorem ipsum...', author: 'Bob Johnson', readTime: '3 min', date: '2022-03-17' },
      // Add more blog data as needed
    ];
  };

  const lastBlogRef = useCallback((node) => {
    if (loading) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        setCurrentPage((prevPage) => prevPage + 1);
      }
    });

    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

  useEffect(() => {
    // Fetch blog data based on the current page and category
    const fetchBlogs = async () => {
      setLoading(true);

      // Simulating an API call
      // Replace this with your actual API call
      const newBlogs = await fetchDataFromAPI(selectedCategory, currentPage);

      setBlogData((prevBlogs) => [...prevBlogs, ...newBlogs]);
      setLoading(false);

      // If no new blogs are fetched, set hasMore to false to stop fetching
      if (newBlogs.length === 0) {
        setHasMore(false);
      }
    };

    fetchBlogs();
  }, [selectedCategory, currentPage]);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setCurrentPage(1); // Reset to the first page when changing categories
    setHasMore(true); // Reset hasMore when changing categories
  };

  const categories = ['All', 'Technology', 'Travel', 'Food', 'Lifestyle'];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <StyledAppBar position="static">
        <StyledToolbar>
          <HeadingContainer>
            <HeadingTypography>{selectedCategory}</HeadingTypography>
          </HeadingContainer>
          <StyledSelect
            value={selectedCategory}
            onChange={handleCategoryChange}
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </StyledSelect>
        </StyledToolbar>
      </StyledAppBar> */}
      <StyledContainer>
       
      {/* <StyledAppBar position="static"> */}
        {/* <StyledToolbar> */}
          <HeadingContainer container spacing={2}>
            <HeadingTypography>{selectedCategory}</HeadingTypography>
          </HeadingContainer>
          {/* <StyledSelect
            value={selectedCategory}
            onChange={handleCategoryChange}
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </StyledSelect> */}
        {/* </StyledToolbar> */}
      {/* </StyledAppBar> */}
     
        <PaginationContainer container spacing={2}>
          {blogData.map((blog, index) => {
            if (blogData.length === index + 1) {
              return (
                <Grid item xs={12} key={index} ref={lastBlogRef}>
                  <StyledCard>
                    <CardContent>
                      <Typography variant="h6">{blog.title}</Typography>
                      <Typography variant="body2">{blog.content}</Typography>
                      <Typography color="textSecondary">Author: {blog.author}</Typography>
                      <Typography color="textSecondary">Read Time: {blog.readTime}</Typography>
                      <Typography color="textSecondary">Date: {blog.date}</Typography>
                    </CardContent>
                  </StyledCard>
                </Grid>
              );
            } else {
              return (
                <Grid item xs={12} key={index}>
                  <StyledCard>
                    <CardContent>
                      <CardTitleTypography variant="h6">{blog.title}</CardTitleTypography>
                      <CardDescTypography variant="body2">{blog.content}</CardDescTypography>
                      <Typography color="textSecondary">Author: {blog.author}</Typography>
                      <Typography color="textSecondary">Read Time: {blog.readTime}</Typography>
                      <Typography color="textSecondary">Date: {blog.date}</Typography>
                    </CardContent>
                  </StyledCard>
                </Grid>
              );
            }
          })}
        </PaginationContainer>
        {loading && <Typography>Loading...</Typography>}
      </StyledContainer>
    </ThemeProvider>
  );
};

export default BlogList;
